import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import React, { useEffect, useState } from 'react'

import MainContainer from "components/layout/MainContainer";

import { routes } from "./utils/constants";

let router = createBrowserRouter(routes);

function App() {
  const [pathname, setPathname] = useState(router.state.location.pathname);

  useEffect(() => {
    const unsubscribe = router.subscribe((state) => {
      setPathname(state.location.pathname);
    });
    return unsubscribe;
  }, []);

  return (
    <MainContainer pathname={pathname}>
      <RouterProvider
        router={router}
        fallbackElement={<p>Loading...</p>}
      />
    </MainContainer>
  );

}

export default App;
